// The Z.A.S. console in the browser: which page to show, and who is signed in.

import { StrictMode, useEffect, useState, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { api } from './api.ts';
import { Invite } from './pages/Invite.tsx';
import { NewSite } from './pages/NewSite.tsx';
import { SetupPage } from './pages/setup/SetupPage.tsx';
import { SignIn } from './pages/SignIn.tsx';
import { Site } from './pages/Site.tsx';
import { Sites } from './pages/Sites.tsx';
import { Team } from './pages/Team.tsx';
import type { Person } from './types.ts';
import { Me, Route, Shell } from './ui.tsx';

function App() {
  const [path, setPath] = useState(location.pathname);
  const [person, setPerson] = useState<Person | null | undefined>(undefined);

  useEffect(() => {
    const onPop = () => setPath(location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  useEffect(() => {
    api<{ person: Person }>('GET', '/auth/me').then(
      (r) => setPerson(r.person),
      () => setPerson(null),
    );
  }, []);

  const go = (to: string) => {
    if (to !== location.pathname) history.pushState(null, '', to);
    setPath(to);
    window.scrollTo(0, 0);
  };

  let page: ReactNode;
  let m: RegExpMatchArray | null;
  if (path === '/invite') page = <Invite />;
  else if (person === undefined) page = <div className="center faint">Loading…</div>;
  else if (!person) page = <SignIn />;
  else if (path === '/' || path === '/sites' || path === '/sign-in') page = <Sites />;
  else if (path === '/new') page = <NewSite />;
  else if (path === '/team') page = <Team />;
  else if ((m = path.match(/^\/sites\/([a-z0-9][a-z0-9-]{1,62})$/))) page = <Site siteId={m[1]} />;
  else if ((m = path.match(/^\/sites\/([a-z0-9][a-z0-9-]{1,62})\/setup\/([a-z]+)$/))) page = <SetupPage siteId={m[1]} step={m[2]} />;
  else
    page = (
      <Shell>
        <h1>Page not found</h1>
      </Shell>
    );

  return (
    <Route.Provider value={{ path, go }}>
      <Me.Provider value={{ person: person ?? null, setPerson }}>{page}</Me.Provider>
    </Route.Provider>
  );
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
